<template>
    <div class="auth">
        <div class="container">
            <div class="auth--box">
                <div class="auth--box--header">
                    <h2 class="auth--title">{{ $t('Account Profile') }}</h2>
                </div>
                <form>
                    <div :class="{ 'form--group': true, 'form--error': showValidMessage && errors.has('street_address') }">
                        <input class="form--control" type="text" :placeholder="$t('street_address')" id="street_address"
                            name="street_address" v-model="model.street_address" v-validate="'required'" maxlength="50">
                        <p v-show="showValidMessage && errors.has('street_address')" class="form--error-text">{{
                            errors.first('street_address') }}</p>
                    </div>
                    <div :class="{ 'form--group': true, 'form--error': showValidMessage && errors.has('zip_code') }">
                        <input class="form--control" type="text" :placeholder="$t('zip_code')" id="zip_code" name="zip_code"
                            v-model="model.zip_code" maxlength="6">
                        <p v-show="showValidMessage && errors.has('zip_code')" class="form--error-text">{{
                            errors.first('zip_code') }}</p>
                    </div>

                    <div :class="{ 'form--group': true, 'form--error': showValidMessage && errors.has('city') }">
                        <input class="form--control" type="text" :placeholder="$t('city')" id="city" name="city"
                            v-model="model.city" v-validate="'required|alpha'" maxlength="50">
                        <p v-show="showValidMessage && errors.has('city')" class="form--error-text">{{ errors.first('city') }}
                        </p>
                    </div>

                    <div :class="{ 'form--group': true, 'form--error': showValidMessage && errors.has('country') }">
                        <v-autocomplete v-model="model.country" id="country" name="country" v-validate="'required'"
                            v-bind:items="countries" item-text="name" item-value="id" v-bind:label="$t('country')">
                        </v-autocomplete>
                        <p v-show="showValidMessage && errors.has('country')" class="form--error-text">{{
                            errors.first('country') }}</p>
                    </div>
                    <button class="btn-round auth-btn" type="button" @click="submit">{{ $t('Save Info') }}</button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import GlobalMixin from '@/GlobalMixin.js'
export default {
    mixins: [GlobalMixin],
    data() {
        return {
        }
    },
    mounted () {
        this.loadProfile();
    },
    methods: {
        loadProfile: function () {
            var self = this;
            self.model = {};
            return new Promise(function (resolve, reject) {
                self.ShowLoading();
                self.axios.get("".concat(process.env.VUE_APP_APIEndPoint, "auth/profile_address/first/"), self.headers)
                    .then(function (res) {
                        self.model = res.data;
                        self.model.country = self.model.country_id;
                        resolve("Success!");
                    })
                    .catch(function (err) {
                        return console.log(err);
                    }).finally(function () {
                        return self.HideLoading();
                    });
            });
        },
        loadLookups: function () {
            this.loadCountry();
            this.loadProfile();
        },
        submit() {
            let self = this;
            self.showValidMessage = true;
            let valid = self.customValidate();
            self.$validator.validate().then(function (result) {
                if (!result || !valid) { ////not valid
                    let detail = $('.form--error').first()[0];
                    if (detail) {
                        detail.scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }
                    return;
                }
                $('.form--error').removeClass("form--error");
                self.closeErrorAlert();
                self.ShowLoading();
                let url = process.env.VUE_APP_APIEndPoint + `auth/profile_address/update/`
                self.axios.put(url, self.model, self.headers)
                    .then(function (res) {
                        self.notify(self.$t('savedSucess'), "success");
                        self.$router.push({ name: 'Home' });
                    })
                    .catch(function (err) {
                        self.displayError(err);
                    }).finally(function () {
                        return self.HideLoading();
                    })
            });
        }
    }
}
</script>
<style>
.form--error>div>div>div>input {
    border-color: #CE0E2D !important;
}

.form--error>span>span>span {
    border-color: #CE0E2D !important;
}</style>